const spinner = document.getElementById('loading'),
      loginForm = document.login_form;

function loading(loading = true) {
    if (spinner){
        spinner.style.display = loading ? 'block' : 'none'
    }
}

if (loginForm) {
    loginForm.onsubmit = function () {
        loading();
    }
}

loading(false);
